// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ResendVerificationCodeRequestModel from '../../model/resend-verification-code-request-model';
import ResendVerificationCodeRequestDTO from '../dto/resend-verification-code-request-dto';
import dtoSchema from '../schemas/resend-verification-code-request-schema';

export default abstract class ResendVerificationCodeRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ResendVerificationCodeRequestDTO>) {
    super();
    if (data) {
      this.email = data.email;
    }
  }
  /**
  * @type {email}
  */
  email?: string;

  static toModel(dto: DeepPartial<ResendVerificationCodeRequestDTO>): ResendVerificationCodeRequestModel;
  static toModel(dto: DeepPartial<ResendVerificationCodeRequestDTO> | undefined | null): ResendVerificationCodeRequestModel | undefined;
  static toModel(dto: DeepPartial<ResendVerificationCodeRequestDTO> | undefined | null): ResendVerificationCodeRequestModel | undefined {
    return dto ? new ResendVerificationCodeRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ResendVerificationCodeRequestModel> | ResendVerificationCodeRequestModel): ResendVerificationCodeRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      email: unwrapped.email,
    } as ResendVerificationCodeRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ResendVerificationCodeRequestModel, can not map to ResendVerificationCodeRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
